{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/widget-area",
	"title": "Widget Area",
	"category": "widgets",
	"attributes": {
		"id": {
			"type": "string"
		},
		"name": {
			"type": "string"
		}
	},
	"supports": {
		"html": false,
		"inserter": false,
		"customClassName": false,
		"reusable": false,
		"__experimentalToolbar": false,
		"__experimentalParentSelector": false,
		"__experimentalDisableBlockOverlay": true
	},
	"editorStyle": "wp-block-widget-area-editor",
	"style": "wp-block-widget-area"
}
